import defaultColor from "@/components/color";

export default {
    cptDataForm: { dataText: '{"value":"按钮"}', dataSource: 1, pollTime: 0, isCache: false },
    attribute: {
        bgColor: defaultColor[0],
        textColor: '#ffffff',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        borderSize: 1,
        borderColor: '#333333',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        lineType: 'solid',
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        isShowCheckbox: 0,
        isChecked: false,
        isShowLoading: 0,
        isLoading: false,
        hoverBgColor: '#333333',
    },
}